import { cn } from '@/lib/utils';
import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackInitiateCheckout } from '../utils/metaPixel';
interface CTAButtonProps {
  label?: string;
  className?: string;
  href?: string;
  variant?: 'gold' | 'dark';
  showArrow?: boolean;
}

/** Checkout oficial y único de 500+ Recetas Keto + Sin TACC (tienda de $14.990). */
export const CHECKOUT_URL = 'https://recetas-keto-sin-tacc.impultienda.ar/checkout';
export function CTAButton({
  label = 'QUIERO LAS 500+ RECETAS',
  className = '',
  href = CHECKOUT_URL,
  variant = 'gold',
  showArrow = true
}: CTAButtonProps) {
  const goesToCheckout = href.startsWith(CHECKOUT_URL);
  const handleClick = () => {
    if (goesToCheckout) trackInitiateCheckout();
  };
  const palette = variant === 'dark' ? 'bg-charcoal text-white hover:bg-charcoal-soft focus-visible:ring-charcoal/40' : 'bg-gold text-charcoal shadow-[0_14px_30px_-10px_rgba(140,100,4,0.55)] hover:bg-[#F5B900] hover:shadow-[0_18px_38px_-12px_rgba(140,100,4,0.6)] focus-visible:ring-gold/50';
  return <a href={href} onClick={handleClick} className={cn('group inline-flex min-h-[58px] items-center justify-center gap-2.5 rounded-xl px-7 py-4 text-center font-display text-[0.95rem] font-bold uppercase leading-tight tracking-[0.03em] transition-[transform,box-shadow,background-color] duration-200 ease-out hover:-translate-y-0.5 focus:outline-none focus-visible:ring-4', palette, className)} data-id="element-67" data-mp="19b963winkame">
      {label}
      {showArrow && <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden strokeWidth={2.5} data-id="element-68" data-mp="1w6zqtgkpw4d5" />}
    </a>;
}